import React, { useCallback, useContext, useEffect, useState } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import Table, { TableRow, TableCell } from "@amzn/meridian/table";
import Icon from "@amzn/meridian/icon";
import editTokens from "@amzn/meridian-tokens/base/icon/edit";
import trashTokens from "@amzn/meridian-tokens/base/icon/trash";
import Input from "@amzn/meridian/input";
import Text from "@amzn/meridian/text";
import RadioButton from "@amzn/meridian/radio-button";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Select, { SelectOption } from "@amzn/meridian/select";
import {
  indirectHCProcessMap,
  INDIRECT_HC_RULE_TYPE_RATIO,
  INDIRECT_HC_RULE_TYPE_FIXED_HC,
  INDIRECT_HC_RULE_TYPE_VOLUME,
  INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION,
  INDIRECT_HC_FIELD_NAME_RULE_TYPE,
  INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES,
  INDIRECT_HC_FIELD_NAME_VOLUME,
  INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS,
  INDIRECT_HC_FIELD_NAME_RATIO_TO_ASSOCIATED_PROCESS,
  FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES,
  MAX_TIME_INTERVALS_COUNT,
  CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES,
  INDIRECT_HC_FIELD_NAME_TIME_INTERVAL,
  INDIRECT_HC_FIELD_NAME_START_TIME,
  INDIRECT_HC_FIELD_NAME_END_TIME,
  INDIRECT_HC_FIELD_NAME_RATE,
  PARENT_PROCESS,
  associateOnlyProcesses,
  MIN_RESOURCES,
  MAX_RESOURCES,
  MAX_RESOURCES_RATE_BASED,
  DEFAULT_SECONDS,
  ZERO_ZERO_ZERO_ZERO_CLOCK,
  DEFAULT_CYCLE,
  PROCESS_RULES,
  PROCESS,
  CYCLE,
} from "./SettingsConstant";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import { SettingsContext } from "./SettingsContext";
import {
  deleteIndirectHCRule,
  getIndirectHCRules,
  setIndirectHCRule,
} from "./SettingsNetworkAPI";
import { logOperationalMetric } from "../../overview/utils/utils";
import TimePicker from "@amzn/meridian/time-picker";
import Column from "@amzn/meridian/column";
import {
  isOverlappingTimeIntervals,
  isValidNumber,
  isWithInTheInterval,
} from "../../util/Util";
import { formatTime } from "../SettingsUtil";
import { metricProcessName } from "../../util/Constants";

const IndirectHCView = (props) => {
  const { viewModel, dispatch } = useContext(SettingsContext);
  const opsClock = viewModel.opsClockData.opsClock;
  const timeZone =
    viewModel.opsClockData && viewModel.opsClockData.nodeTimeZone
      ? viewModel.opsClockData.nodeTimeZone
      : Intl.DateTimeFormat().resolvedOptions().timeZone;
  const opsClockClockEvents = opsClock ? opsClock.clockEvents : "";
  const [errorMessageForMinAssociates, setErrorMessageForMinAssociates] =
    useState("");
  const [
    errorMessageForRatioToAssociateProcess,
    setErrorMessageForRatioToAssociateProcess,
  ] = useState("");
  const [errorMessageForRate, setErrorMessageForRate] = useState("");
  const { indirectHCData } = viewModel.settingsData;
  const [numOfTimePicker, setNumOfTimePickers] = useState(0);
  const [isConfirmDisabled, setIsConfirmDisabled] = useState(false);
  const [
    fixedHCTimeIntervalsWithMinAssociates,
    setFixedHCTimeIntervalsWithMinAssociates,
  ] = useState([]);
  const isUserAuthorisedForSettingsEdit =
    props.props.isUserAuthorisedForSettingsEdit;
  const [cycle, setCycle] = useState(DEFAULT_CYCLE);
  const allCycles = viewModel.allCycles;
  /*********************
   *                   *
   *        hooks      *
   *                   *
   *********************/

  const [form, setForm] = useState(JSON.parse(JSON.stringify(DEFAULT_FORM)));
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getTimeFromOpsClock = (epochTime) => {
    let date = epochTime ? new Date(epochTime * 1000) : null;
    let dateTimeString = date
      ? date.toLocaleString("en-US", { timeZone })
      : null;
    return dateTimeString ? formatTime(dateTimeString) : "";
  };

  const getOpsClockTimeLimits = (cycleName) => {
    let smallestStartTime = "";
    let largestEndTime = "";
    if (opsClock && opsClockClockEvents) {
      const filteredOpsClock = opsClockClockEvents.filter(
        (clockEvent) => clockEvent.cycleName === cycleName,
      );

      if (filteredOpsClock) {
        const startTimes = filteredOpsClock.flatMap((clockEvent) =>
          clockEvent.timeIntervals.map((interval) => interval.startTime),
        );
        const endTimes = filteredOpsClock.flatMap((clockEvent) =>
          clockEvent.timeIntervals.map((interval) => interval.endTime),
        );

        smallestStartTime = Math.min(...startTimes);
        largestEndTime = Math.max(...endTimes);

        smallestStartTime = `${getTimeFromOpsClock(
          smallestStartTime,
        )}:${DEFAULT_SECONDS}`;
        largestEndTime = `${getTimeFromOpsClock(
          largestEndTime,
        )}:${DEFAULT_SECONDS}`;
      }
    }
    return [smallestStartTime, largestEndTime];
  };

  useEffect(() => {
    fetchIndirectHCData();
  }, []);

  /*********************
   *                   *
   *      handlers     *
   *                   *
   *********************/

  const onAddNewTimeIntervalClickButton = () => {
    setErrorMessageForMinAssociates("");
    setFixedHCTimeIntervalsWithMinAssociates([
      ...fixedHCTimeIntervalsWithMinAssociates,
      JSON.parse(JSON.stringify(DEFAULT_FHCTIWMA)),
    ]);
    setNumOfTimePickers(numOfTimePicker + 1);
  };

  const onConfirmDeleteRule = (rule) => {
    deleteRule(rule);
  };

  const validateFixedHCTimeBoundAssociateItem = (item, isRateBased, rate) => {
    const minAssociates = item[INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES];
    const timeInterval = item[INDIRECT_HC_FIELD_NAME_TIME_INTERVAL];

    if (isValidNumber(minAssociates) && timeInterval) {
      const localStartTime = timeInterval[INDIRECT_HC_FIELD_NAME_START_TIME];
      const localEndTime = timeInterval[INDIRECT_HC_FIELD_NAME_END_TIME];
      return (
        !localStartTime ||
        !localEndTime ||
        minAssociates === "" ||
        localStartTime === "" ||
        localEndTime === "" ||
        localStartTime === localEndTime ||
        (isRateBased
          ? isInvalidValidHeadCountNumberForRate(minAssociates) ||
            isInvalidRate(minAssociates, rate)
          : minAssociates * 1 > MAX_RESOURCES)
      );
    }
    return true;
  };

  const isValidOpsClockTimeRange = (timeInterval, cycleName) => {
    const startTime = timeInterval[INDIRECT_HC_FIELD_NAME_START_TIME];
    const endTime = timeInterval[INDIRECT_HC_FIELD_NAME_END_TIME];
    let [opsClockInductStartTime, opsClockDispatchEndTime] =
      getOpsClockTimeLimits(cycleName);
    const isNextDay = opsClockInductStartTime >= opsClockDispatchEndTime;
    let isValid = false;
    if (isNextDay) {
      if (
        opsClockInductStartTime > startTime &&
        startTime >= ZERO_ZERO_ZERO_ZERO_CLOCK
      ) {
        isValid =
          isValid ||
          (startTime <= opsClockDispatchEndTime &&
            endTime <= opsClockDispatchEndTime);
      } else if (opsClockInductStartTime <= startTime) {
        isValid =
          isValid ||
          endTime >= opsClockInductStartTime ||
          endTime <= opsClockDispatchEndTime;
      }
      return isValid;
    } else {
      return (
        isWithInTheInterval(
          startTime,
          opsClockInductStartTime,
          opsClockDispatchEndTime,
        ) &&
        isWithInTheInterval(
          endTime,
          opsClockInductStartTime,
          opsClockDispatchEndTime,
        )
      );
    }
  };

  const isInvalidValidHeadCountNumber = (minAssociates) => {
    return (
      minAssociates * 1 < MIN_RESOURCES || minAssociates * 1 > MAX_RESOURCES
    );
  };

  const isInvalidValidHeadCountNumberForRate = (minAssociates) => {
    return (
      minAssociates * 1 < MIN_RESOURCES ||
      minAssociates * 1 > MAX_RESOURCES_RATE_BASED
    );
  };

  const isInvalidRate = (minAssociates, rate) => {
    return minAssociates * 1 > rate * 1;
  };

  const onConfirmModal = () => {
    const {
      process,
      ruleType,
      minAssociates,
      associatedProcess,
      ratioToAssociatedProcess,
      volume,
      rate,
    } = form;
    const errMsg = `Failed to ${
      form["isUpdate"] ? "update" : "create"
    } rule, please enter the required information.`;
    if (
      errorMessageForMinAssociates !== "" ||
      (ruleType === INDIRECT_HC_RULE_TYPE_RATIO &&
        errorMessageForRatioToAssociateProcess !== "")
    ) {
      alert("Please resolve all errors");
      return false;
    }

    if (numOfTimePicker === 0 && (!process || !minAssociates)) {
      alert(errMsg);
      return false;
    }

    if (numOfTimePicker > 0 && !process) {
      alert(errMsg);
      return false;
    }

    if (ruleType === INDIRECT_HC_RULE_TYPE_RATIO) {
      if (!associatedProcess || !ratioToAssociatedProcess) {
        alert(errMsg);
        return false;
      } else if (
        isInvalidValidHeadCountNumber(minAssociates) ||
        isInvalidValidHeadCountNumber(ratioToAssociatedProcess)
      ) {
        alert(
          `Min.Associates should be greater than ${
            MIN_RESOURCES - 1
          } and less than or equal to ${MAX_RESOURCES}`,
        );
        return false;
      }
    }

    if (ruleType === INDIRECT_HC_RULE_TYPE_FIXED_HC) {
      let isTimeIntervalsEnabled =
        fixedHCTimeIntervalsWithMinAssociates &&
        fixedHCTimeIntervalsWithMinAssociates.length > 0;

      if (isTimeIntervalsEnabled) {
        let isNotValid = false;
        fixedHCTimeIntervalsWithMinAssociates.forEach((timeInterval) => {
          isNotValid =
            isNotValid ||
            validateFixedHCTimeBoundAssociateItem(
              timeInterval,
              indirectHCProcessMap[process]["isAutoProcess"],
              rate,
            );
        });

        if (isNotValid) {
          const errMsgForTimeIntervals = `Required Start Time / End Time / Headcount (should be less than or equal to ${
            indirectHCProcessMap[process]["isAutoProcess"]
              ? MAX_RESOURCES_RATE_BASED
              : MAX_RESOURCES
          }) ${
            indirectHCProcessMap[process]["isAutoProcess"]
              ? "/ Headcount should be less than or equal to Rate"
              : ""
          }`;
          alert(errMsgForTimeIntervals);
          return false;
        } else {
          let isOpsClockNotValid = false;
          fixedHCTimeIntervalsWithMinAssociates.forEach((rule) => {
            isOpsClockNotValid =
              isOpsClockNotValid ||
              !isValidOpsClockTimeRange(rule["timeInterval"], cycle);
          });
          if (isOpsClockNotValid) {
            const errMsgForTimeIntervals = `Time intervals must be in OpsClock range`;
            alert(errMsgForTimeIntervals);
            return false;
          } else {
            let hasOverlappingTimeIntervals = false;
            for (
              let i = 0;
              i < fixedHCTimeIntervalsWithMinAssociates.length - 1;
              i++
            ) {
              for (
                let j = i + 1;
                j < fixedHCTimeIntervalsWithMinAssociates.length;
                j++
              ) {
                if (
                  isOverlappingTimeIntervals(
                    fixedHCTimeIntervalsWithMinAssociates[i].timeInterval,
                    fixedHCTimeIntervalsWithMinAssociates[j].timeInterval,
                  ) &&
                  !hasOverlappingTimeIntervals
                ) {
                  hasOverlappingTimeIntervals = true;
                }
              }
            }
            if (hasOverlappingTimeIntervals) {
              const errMsgForTimeIntervals = `Overlapping time intervals exists. Time intervals must not overlap`;
              alert(errMsgForTimeIntervals);
              return false;
            }
          }
        }
      }

      if (indirectHCProcessMap[process]["isAutoProcess"]) {
        if (!rate) {
          alert(errMsg);
          return false;
        } else if (
          !isTimeIntervalsEnabled &&
          isInvalidValidHeadCountNumberForRate(minAssociates)
        ) {
          alert(
            `Headcount should be greater than ${
              MIN_RESOURCES - 1
            } and less than or equal to ${MAX_RESOURCES_RATE_BASED}`,
          );
          return false;
        } else if (rate * 1 < MIN_RESOURCES) {
          alert(`Rate should be greater than ${MIN_RESOURCES - 1}`);
          return false;
        } else if (
          !isTimeIntervalsEnabled &&
          isInvalidRate(minAssociates, rate)
        ) {
          alert("Headcount should be less than or equal to Rate");
          return false;
        }
      }

      if (minAssociates * 1 > MAX_RESOURCES) {
        alert(`Headcount should be less than or equal to ${MAX_RESOURCES}`);
        return false;
      }
    }

    const param = {
      process,
      ruleType,
      minAssociates,
      cycleName: cycle,
    };

    if (ruleType === INDIRECT_HC_RULE_TYPE_FIXED_HC) {
      param[INDIRECT_HC_FIELD_NAME_RATE] = rate;
      param[INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS] =
        PARENT_PROCESS in indirectHCProcessMap[process]
          ? indirectHCProcessMap[process][PARENT_PROCESS]
          : null;
    }
    if (ruleType === INDIRECT_HC_RULE_TYPE_RATIO) {
      param["associatedProcess"] = associatedProcess;
      param["ratioToAssociatedProcess"] = ratioToAssociatedProcess;
    } else if (ruleType === INDIRECT_HC_RULE_TYPE_VOLUME) {
      param["volume"] = volume;
    } else if (
      ruleType === INDIRECT_HC_RULE_TYPE_FIXED_HC &&
      numOfTimePicker > 0
    ) {
      param[CURR_FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES] =
        fixedHCTimeIntervalsWithMinAssociates;
      delete param[INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES];
    }
    upsertIndirectHCRule(param);
  };

  const onChangeRuleType = (ruleType) => {
    if (form["isUpdate"]) {
      setForm({
        ...form,
        ruleType,
      });
    } else {
      setForm({
        ...form,
        ruleType,
        associatedProcess: "",
        ratioToAssociatedProcess: "",
        volume: "",
        rate: "",
      });
    }
  };

  const onClickEditRule = (rule) => {
    const {
      ruleType,
      process,
      minAssociates,
      ratioToAssociatedProcess = "",
      associatedProcess = "",
      volume = "",
      timeIntervalsWithMinAssociates,
      rate,
    } = rule;
    setForm({
      isUpdate: true,
      ruleType,
      process,
      minAssociates,
      ratioToAssociatedProcess,
      associatedProcess,
      volume,
      rate,
    });

    if (timeIntervalsWithMinAssociates) {
      const cloned = JSON.parse(JSON.stringify(timeIntervalsWithMinAssociates));
      setFixedHCTimeIntervalsWithMinAssociates(cloned);
      setNumOfTimePickers(cloned.length);
    }
    setIsConfirmDisabled(true);
    onOpenModal();
  };

  const onChangeProcess = (process) => {
    setForm({
      ...form,
      process,
    });
  };

  const onChangeMinAssociates = (minAssociates) => {
    if (!minAssociates.match(/^[0-9]+$/)) {
      setErrorMessageForMinAssociates(
        "Please enter a valid number for resources (Min.Associates/Machines)",
      );
    } else {
      setErrorMessageForMinAssociates("");
    }
    setIsConfirmDisabled(false);
    setForm({
      ...form,
      minAssociates,
    });
  };

  const onChangeAssociatedProcess = (associatedProcess) => {
    setForm({
      ...form,
      associatedProcess,
    });
    setIsConfirmDisabled(false);
  };

  const onChangeRatioToAssociatedProcess = (ratioToAssociatedProcess) => {
    if (!ratioToAssociatedProcess.match(/^[0-9]+$/)) {
      setErrorMessageForRatioToAssociateProcess(
        "Please enter a valid number for minimum associates",
      );
    } else {
      setErrorMessageForRatioToAssociateProcess("");
    }
    setIsConfirmDisabled(false);
    setForm({
      ...form,
      ratioToAssociatedProcess,
    });
  };

  const onChangeRate = (rate) => {
    if (!rate.match(/^[0-9]+$/)) {
      setErrorMessageForRate("Please enter a valid number for Rate");
    } else {
      setErrorMessageForRate("");
    }
    setIsConfirmDisabled(false);
    setForm({
      ...form,
      rate,
    });
  };

  const clearForm = () => {
    setForm(JSON.parse(JSON.stringify(DEFAULT_FORM)));
  };

  const onOpenModal = useCallback(() => {
    setOpen(true);
  }, []);

  const onCloseModal = useCallback(() => {
    clearForm();
    setErrorMessageForMinAssociates("");
    setErrorMessageForRatioToAssociateProcess("");
    setErrorMessageForRate("");
    setNumOfTimePickers(0);
    setFixedHCTimeIntervalsWithMinAssociates([]);
    setOpen(false);
  }, []);

  /*********************
   *                   *
   *     api calls     *
   *                   *
   *********************/

  const deleteRule = async (rule) => {
    if (isLoading) return false;
    await setIsLoading(true);
    const startTime = Date.now();
    rule[CYCLE] = cycle;
    deleteIndirectHCRule(rule)
      .then((res) => {
        if (res.status === 200 && res.data && res.data.statusCode === "OK") {
          dispatch({ type: "DELETE_INDIRECT_HC_RULE", data: rule });
          logOperationalMetric(
            startTime,
            metricProcessName,
            "deleteRuleConfiguration",
            true,
          );
        } else {
          logOperationalMetric(
            startTime,
            metricProcessName,
            "deleteRuleConfiguration",
            false,
          );
          alert(ERROR_MSG_500);
        }
      })
      .catch((err) => {
        alert(ERROR_MSG_500);
        logOperationalMetric(
          startTime,
          metricProcessName,
          "deleteRuleConfiguration",
          false,
        );
      })
      .finally(() => {
        dispatch({ type: "CLOSE_DELETE_INDIRECT_HC_RULE_MODAL" });
        setIsLoading(false);
      });
  };

  const fetchIndirectHCData = () => {
    const startTime = Date.now();
    getIndirectHCRules()
      .then((res) => {
        if (res.status === 200 && res["data"] && res["data"][0]) {
          let data = res["data"];

          data.map((item, index) =>
            Object.keys(data[index][PROCESS_RULES]).forEach((key) => {
              const ruleConfig =
                data[index][PROCESS_RULES][key][
                  INDIRECT_HC_FIELD_NAME_HEADCOUNT_RULE_CONFIGURATION
                ];
              data[index][PROCESS_RULES][key] = {
                ...data[index][PROCESS_RULES][key],
                ruleType: ruleConfig[INDIRECT_HC_FIELD_NAME_RULE_TYPE],
                minAssociates:
                  ruleConfig[INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES],
                volume: ruleConfig[INDIRECT_HC_FIELD_NAME_VOLUME],
                associatedProcess:
                  ruleConfig[INDIRECT_HC_FIELD_NAME_ASSOCIATED_PROCESS],
                ratioToAssociatedProcess:
                  ruleConfig[
                    INDIRECT_HC_FIELD_NAME_RATIO_TO_ASSOCIATED_PROCESS
                  ],
                timeIntervalsWithMinAssociates:
                  ruleConfig[FIXED_HC_TIME_INTERVALS_MIN_ASSOCIATES],
                rate: ruleConfig[INDIRECT_HC_FIELD_NAME_RATE],
                cycleName: data[index][CYCLE],
                ...ruleConfig,
              };
            }),
          );
          dispatch({ type: "RECEIVE_INDIRECT_HC_DATA", data });
          logOperationalMetric(
            startTime,
            metricProcessName,
            "getRuleConfiguration",
            true,
          );
        } else {
          logOperationalMetric(
            startTime,
            metricProcessName,
            "getRuleConfiguration",
            false,
          );
        }
      })
      .catch((err) => {
        alert(ERROR_MSG_500);
        logOperationalMetric(
          startTime,
          metricProcessName,
          "getRuleConfiguration",
          false,
        );
      });
  };

  const upsertIndirectHCRule = async (param) => {
    if (isLoading) return false;
    await setIsLoading(true);
    const startTime = Date.now();
    setIndirectHCRule(param)
      .then((res) => {
        if (res.status === 200 && res.data.statusCode === "OK") {
          dispatch({
            type: "SET_INDIRECT_HC_RULE",
            data: param,
          });
          logOperationalMetric(
            startTime,
            metricProcessName,
            "updateRuleConfiguration",
            true,
          );
        } else {
          alert(ERROR_MSG_500);
          logOperationalMetric(
            startTime,
            metricProcessName,
            "updateRuleConfiguration",
            false,
          );
        }
      })
      .catch((err) => {
        alert(ERROR_MSG_500);
        logOperationalMetric(
          startTime,
          metricProcessName,
          "updateRuleConfiguration",
          false,
        );
      })
      .finally(() => {
        setIsLoading(false);
        onCloseModal();
      });
  };

  /*********************
   *                   *
   *      renderers    *
   *                   *
   *********************/

  const renderRow = (item) => {
    const {
      process,
      ruleType,
      associatedProcess,
      minAssociates,
      volume,
      ratioToAssociatedProcess,
      timeIntervalsWithMinAssociates,
      rate,
    } = item;
    const processName = indirectHCProcessMap[process]["processName"];
    let ruleDescription;

    if (
      ruleType === INDIRECT_HC_RULE_TYPE_FIXED_HC &&
      isValidNumber(minAssociates)
    ) {
      if (isValidNumber(rate)) {
        ruleDescription = `${minAssociates} automated machines each processing ${rate} packages per hour`;
      } else {
        ruleDescription = `Minimum ${minAssociates} ${processName} required`;
      }
    } else if (ruleType === INDIRECT_HC_RULE_TYPE_VOLUME) {
      ruleDescription = `Minimum ${minAssociates} ${processName} for every ${volume} packages`;
    } else if (ruleType === INDIRECT_HC_RULE_TYPE_RATIO) {
      const associatedProcessName =
        indirectHCProcessMap[associatedProcess]["processName"];
      ruleDescription = `Minimum ${minAssociates} ${processName} for ${ratioToAssociatedProcess} ${associatedProcessName}`;
    }
    return (
      <TableRow
        highlightOnHover={true}
        key={process}
        backgroundColor={
          item[INDIRECT_HC_FIELD_NAME_RULE_TYPE] ===
          INDIRECT_HC_RULE_TYPE_VOLUME
            ? "secondary"
            : "primary"
        }
      >
        <TableCell>
          <div style={{ paddingRight: 25 }}>{processName}</div>
        </TableCell>
        <TableCell>
          {timeIntervalsWithMinAssociates &&
          timeIntervalsWithMinAssociates.length > 0
            ? timeIntervalsWithMinAssociates.map((timeInterval) => {
                let rule = isValidNumber(rate)
                  ? ` ${timeInterval.minAssociates} ${processName} required between  
                                ${timeInterval.timeInterval.localStartTime} and ${timeInterval.timeInterval.localEndTime} with rate ${rate} packages per hour`
                  : `Minimum ${timeInterval.minAssociates} ${processName}
                                   required between ${timeInterval.timeInterval.localStartTime} and ${timeInterval.timeInterval.localEndTime}`;

                return <li> {rule} </li>;
              })
            : ruleDescription}
        </TableCell>
        {isUserAuthorisedForSettingsEdit ? (
          <TableCell>
            <div
              style={{
                flexDirection: "row",
                display: "flex",
                paddingLeft: "25px",
              }}
            >
              <div onClick={() => onClickEditRule(item)}>
                {item[INDIRECT_HC_FIELD_NAME_RULE_TYPE] !==
                INDIRECT_HC_RULE_TYPE_VOLUME ? (
                  <Text>
                    <Icon tokens={editTokens} />
                  </Text>
                ) : (
                  ""
                )}
              </div>
              &nbsp;
              <div
                onClick={() =>
                  dispatch({
                    type: "OPEN_DELETE_INDIRECT_HC_RULE_MODAL",
                    data: item,
                  })
                }
              >
                {
                  <Text color={"error"}>
                    <Icon tokens={trashTokens} />
                  </Text>
                }
              </div>
            </div>
          </TableCell>
        ) : (
          ""
        )}
      </TableRow>
    );
  };

  const renderFixedHCInputs = () => {
    const filteredConfigByCycle = Object.values(indirectHCData).filter(
      (obj) => obj[CYCLE] === cycle,
    );
    const processRules =
      filteredConfigByCycle.length > 0
        ? filteredConfigByCycle[0].processRules
        : {};
    const existingProcessList = parseProcessRules(processRules);
    let processListForSelect = getProcessListForSelect(existingProcessList);
    if (form["isUpdate"]) {
      processListForSelect = getProcessListForSelect(
        existingProcessList,
        form[PROCESS],
      );
    }

    return (
      <div style={formWrapperStyle}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "flex-end",
              marginBottom: "2em",
            }}
          >
            <div style={inputWrapperStyle}>
              <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                <FormattedMessage
                  id="settings.indirecthc.modal.process"
                  defaultMessage={PROCESS}
                />
              </Text>
              <Select
                value={form[PROCESS]}
                onChange={onChangeProcess}
                placeholder=""
                disabled={form["isUpdate"]}
              >
                {processListForSelect.map((process) => (
                  <SelectOption
                    label={process["processName"]}
                    value={process[PROCESS]}
                  />
                ))}
              </Select>
            </div>
            <div
              style={{
                position: "relative",
                bottom: "0.7em",
                marginLeft: "1em",
                marginRight: "1em",
              }}
            >
              <FormattedMessage
                id="settings.indirecthc.modal.requires"
                defaultMessage="requires"
              />
            </div>
            <div style={inputWrapperStyle}>
              <div className="overrideTime">
                <Text
                  tag="label"
                  type="b200"
                  color="primary"
                  htmlFor="my-input"
                >
                  <FormattedMessage
                    id="settings.indirecthc.modal.headcount"
                    defaultMessage="Headcount"
                  />
                </Text>
              </div>
              <Input
                id="my-input"
                value={form[INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES]}
                onChange={onChangeMinAssociates}
                type="number"
                placeholder=""
                disabled={numOfTimePicker !== 0}
              />
            </div>
          </div>
          <Text color={"error"}>{errorMessageForMinAssociates}</Text>
        </div>
        {form[PROCESS] &&
        indirectHCProcessMap[form[PROCESS]]["isAutoProcess"] ? (
          <div>
            <p style={{ textAlign: "center" }}>
              <FormattedMessage
                id="settings.indirecthc.modal.workingAt"
                defaultMessage="Working At"
              />
            </p>
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <div style={{ display: "flex", marginBottom: "2em" }}>
                  <div style={inputWrapperStyle}>
                    <Text
                      tag="label"
                      type="b200"
                      color="primary"
                      htmlFor="my-input"
                    >
                      <FormattedMessage
                        id="settings.indirecthc.modal.rate"
                        defaultMessage="Rate"
                      />
                    </Text>
                    <Input
                      value={form["rate"]}
                      onChange={onChangeRate}
                      type="number"
                      placeholder=""
                    />
                  </div>
                </div>
                <Text color={"error"}>{errorMessageForRate}</Text>
              </div>
            </div>
          </div>
        ) : (
          <div />
        )}
        <div>{renderTimeIntervalsDatePickers()}</div>
      </div>
    );
  };

  const renderTimeIntervalsDatePickers = () => {
    if (fixedHCTimeIntervalsWithMinAssociates) {
      return Object.keys(fixedHCTimeIntervalsWithMinAssociates).map(
        (datePickerId) => renderTimeIntervalDatePicker(datePickerId),
      );
    }
  };

  const renderTimeIntervalDatePicker = (datePickerId) => {
    const fixesHCTIObj = fixedHCTimeIntervalsWithMinAssociates[datePickerId];
    const localStartTime = fixesHCTIObj.timeInterval.localStartTime;
    const localEndTime = fixesHCTIObj.timeInterval.localEndTime;
    const minAssociates = fixesHCTIObj.minAssociates;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Row>
          <Column spacing="100">
            <Text tag="label" type="b200" color="primary" htmlFor="my-input">
              <FormattedMessage
                id="settings.indirecthc.modal.startTime"
                defaultMessage="Start Time"
              />
            </Text>
            <TimePicker
              width={150}
              value={localStartTime}
              placeholder="HH:MM"
              onChange={(newStartTime) =>
                updateFixedHCTimeIntervalsWithMinAssociates(
                  datePickerId,
                  "localStartTime",
                  newStartTime,
                )
              }
              format={{ hourCycle: "h23", hour: "2-digit", minute: "2-digit" }}
              invalidInputMessage="Invalid time. The correct time format is hour:minute."
            />
          </Column>
          <Column spacing="100">
            <Text tag="label" type="b200" color="primary" htmlFor="my-input">
              <FormattedMessage
                id="settings.indirecthc.modal.endTime"
                defaultMessage="End Time"
              />
            </Text>
            <TimePicker
              width={150}
              value={localEndTime}
              placeholder="HH:MM"
              onChange={(newEndTime) =>
                updateFixedHCTimeIntervalsWithMinAssociates(
                  datePickerId,
                  "localEndTime",
                  newEndTime,
                )
              }
              format={{ hourCycle: "h23", hour: "2-digit", minute: "2-digit" }}
              invalidInputMessage="Invalid time. The correct time format is hour:minute."
            />
          </Column>
          <Column spacing="100">
            <Text tag="label" type="b200" color="primary" htmlFor="my-input">
              <FormattedMessage
                id="settings.indirecthc.modal.headcount"
                defaultMessage="Headcount"
              />
            </Text>
            <Input
              width={150}
              value={minAssociates}
              onChange={(minAssociates) =>
                updateFixedHCTimeIntervalsWithMinAssociates(
                  datePickerId,
                  INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES,
                  minAssociates,
                )
              }
              type="number"
              placeholder=""
            />
          </Column>
          <Column spacing="100">
            &nbsp;
            <div
              onClick={() =>
                deleteFixedHCTimeIntervalsWithMinAssociates(datePickerId)
              }
            >
              <Text color={"error"}>
                <Icon tokens={trashTokens} />
              </Text>
            </div>
          </Column>
        </Row>
      </div>
    );
  };

  const updateFixedHCTimeIntervalsWithMinAssociates = (index, key, value) => {
    if (!value) {
      setErrorMessageForMinAssociates(
        "Required Start Time / End Time / Resources",
      );
    } else {
      setErrorMessageForMinAssociates("");
    }

    let curr_state = [...fixedHCTimeIntervalsWithMinAssociates];
    if (key === INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES) {
      curr_state[index][key] = value;
    } else {
      curr_state[index][INDIRECT_HC_FIELD_NAME_TIME_INTERVAL][key] = value;
    }
    setFixedHCTimeIntervalsWithMinAssociates(curr_state);
    setIsConfirmDisabled(false);
  };

  const deleteFixedHCTimeIntervalsWithMinAssociates = (id) => {
    let filteredArr = [...fixedHCTimeIntervalsWithMinAssociates];
    filteredArr.splice(id, 1);
    setNumOfTimePickers(numOfTimePicker - 1);
    setFixedHCTimeIntervalsWithMinAssociates(filteredArr);
    setIsConfirmDisabled(false);
    setErrorMessageForMinAssociates("");
    dispatch({
      type: "DELETE_FIXED_HC_TIME_INTERVAL",
      data: fixedHCTimeIntervalsWithMinAssociates,
    });
  };

  const renderRatioBasedRuleInputs = () => {
    const filteredConfigByCycle = Object.values(indirectHCData).filter(
      (obj) => obj[CYCLE] === cycle,
    );
    const processRules =
      filteredConfigByCycle.length > 0
        ? filteredConfigByCycle[0].processRules
        : {};
    const existingProcessList = parseProcessRules(processRules);
    let processListForSelect = getProcessListForSelect(existingProcessList);
    if (form["isUpdate"]) {
      processListForSelect = getProcessListForSelect(
        existingProcessList,
        form[PROCESS],
      );
    }
    const defaultProcessList = Object.keys(indirectHCProcessMap).map(
      (process) => indirectHCProcessMap[process],
    );
    return (
      <div style={formWrapperStyle}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex" }}>
            <div style={{ ...inputWrapperStyle, marginRight: "2em" }}>
              <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                <FormattedMessage
                  id="settings.indirecthc.modal.minAssociates"
                  defaultMessage="Min. associates"
                />
              </Text>
              <Input
                value={form[INDIRECT_HC_FIELD_NAME_MIN_ASSOCIATES]}
                onChange={onChangeMinAssociates}
                type="number"
                placeholder=""
              />
            </div>
            <div style={inputWrapperStyle}>
              <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                <FormattedMessage
                  id="settings.indirecthc.modal.process"
                  defaultMessage={PROCESS}
                />
              </Text>
              <Select
                value={form[PROCESS]}
                onChange={onChangeProcess}
                placeholder=""
                disabled={form["isUpdate"]}
              >
                {processListForSelect.map((process) => (
                  <SelectOption
                    label={process["processName"]}
                    value={process[PROCESS]}
                  />
                ))}
              </Select>
            </div>
          </div>
        </div>
        <p style={{ textAlign: "center" }}>
          <FormattedMessage
            id="settings.indirecthc.modal.per"
            defaultMessage="per"
          />
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", marginBottom: "2em" }}>
            <div style={{ ...inputWrapperStyle, marginRight: "2em" }}>
              <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                <FormattedMessage
                  id="settings.indirecthc.modal.minAssociates"
                  defaultMessage="Min. associates"
                />
              </Text>
              <Input
                value={form["ratioToAssociatedProcess"]}
                onChange={onChangeRatioToAssociatedProcess}
                type="number"
                placeholder=""
              />
            </div>
            <div style={inputWrapperStyle}>
              <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                <FormattedMessage
                  id="settings.indirecthc.modal.process"
                  defaultMessage={PROCESS}
                />
              </Text>
              <Select
                value={form["associatedProcess"]}
                onChange={onChangeAssociatedProcess}
                placeholder=""
              >
                {defaultProcessList.map((process) => (
                  <SelectOption
                    label={process["processName"]}
                    value={process[PROCESS]}
                  />
                ))}
              </Select>
            </div>
          </div>
          <Text color={"error"}>{errorMessageForMinAssociates}</Text>
          {errorMessageForMinAssociates === "" ? (
            <Text color={"error"}>
              {errorMessageForRatioToAssociateProcess}
            </Text>
          ) : null}
        </div>
      </div>
    );
  };

  const renderModal = () => {
    const radioBtnWrapperStyles = {
      marginRight: "1em",
      marginTop: "1em",
    };
    return (
      <React.Fragment>
        <Modal
          title={
            form["isUpdate"]
              ? `Edit Rule for Cycle: ${cycle}`
              : `New Rule for Cycle: ${cycle}`
          }
          open={open}
          onClose={onCloseModal}
          scrollContainer="viewport"
          closeLabel="Close"
          describedById="modal-description"
          width={"50em"}
        >
          <div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-evenly",
              }}
            >
              <div style={radioBtnWrapperStyles}>
                <RadioButton
                  checked={
                    form[INDIRECT_HC_FIELD_NAME_RULE_TYPE] ===
                    INDIRECT_HC_RULE_TYPE_FIXED_HC
                  }
                  onChange={onChangeRuleType}
                  name={INDIRECT_HC_FIELD_NAME_RULE_TYPE}
                  value={INDIRECT_HC_RULE_TYPE_FIXED_HC}
                >
                  <FormattedMessage
                    id="settings.indirecthc.modal.fixedHC"
                    defaultMessage="Fixed HC"
                  />
                </RadioButton>
              </div>
              <div style={radioBtnWrapperStyles}>
                <RadioButton
                  checked={
                    form[INDIRECT_HC_FIELD_NAME_RULE_TYPE] ===
                    INDIRECT_HC_RULE_TYPE_RATIO
                  }
                  onChange={onChangeRuleType}
                  name={INDIRECT_HC_FIELD_NAME_RULE_TYPE}
                  value={INDIRECT_HC_RULE_TYPE_RATIO}
                >
                  <FormattedMessage
                    id="settings.indirecthc.modal.ratioBasedRule"
                    defaultMessage="Ratio based rule"
                  />
                </RadioButton>
              </div>
            </div>
            {form[INDIRECT_HC_FIELD_NAME_RULE_TYPE] ===
            INDIRECT_HC_RULE_TYPE_FIXED_HC
              ? renderFixedHCInputs()
              : renderRatioBasedRuleInputs()}
            <ModalFooter>
              <div style={modalFooter}>
                <Row alignmentHorizontal="right" widths="fit">
                  <Button type="secondary" size="small" onClick={onCloseModal}>
                    <FormattedMessage
                      id="settings.indirecthc.modal.cancel"
                      defaultMessage="Cancel"
                    />
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    onClick={onConfirmModal}
                    disabled={isConfirmDisabled}
                  >
                    <FormattedMessage
                      id="settings.indirecthc.modal.confirm"
                      defaultMessage="Confirm"
                    />
                  </Button>
                  {form[INDIRECT_HC_FIELD_NAME_RULE_TYPE] ===
                  INDIRECT_HC_RULE_TYPE_FIXED_HC ? (
                    <Button
                      type="primary"
                      size="small"
                      onClick={onAddNewTimeIntervalClickButton}
                      disabled={
                        fixedHCTimeIntervalsWithMinAssociates
                          ? fixedHCTimeIntervalsWithMinAssociates.length >=
                            MAX_TIME_INTERVALS_COUNT
                          : false
                      }
                    >
                      <FormattedMessage
                        id="settings.indirecthc.moddal.addBreak"
                        defaultMessage="Add Time Interval"
                      />
                    </Button>
                  ) : (
                    ""
                  )}
                </Row>
              </div>
            </ModalFooter>
          </div>
        </Modal>
      </React.Fragment>
    );
  };
  return (
    <div>
      {renderModal()}
      <DeleteRuleModal onConfirm={onConfirmDeleteRule} />

      <Row
        spacingInset="small 400"
        backgroundColor="secondary"
        className="opsClockFilter"
      >
        <div className="dateAndCycleFilter">
          <Select value={cycle} onChange={setCycle} width={130} size="medium">
            {allCycles.map((cycle) => {
              return (
                <SelectOption
                  value={cycle.cycleName}
                  label={cycle.cycleName}
                  key={cycle.cycleName}
                />
              );
            })}
          </Select>
        </div>
        <div>
          <Button
            type="primary"
            onClick={onOpenModal}
            disabled={!isUserAuthorisedForSettingsEdit}
            size={"medium"}
          >
            <FormattedMessage
              id="settings.indirecthc.modal.add"
              defaultMessage="Add"
            />
          </Button>
        </div>
      </Row>
      <Table
        headerRows={1}
        showDividers={true}
        spacing="medium"
        showStripes={false}
      >
        <TableRow highlightOnHover={true}>
          <TableCell>
            <FormattedMessage
              id="settings.indirecthc.header.process"
              defaultMessage={PROCESS}
            />
          </TableCell>
          <TableCell>
            <FormattedMessage
              id="settings.indirecthc.header.rule"
              defaultMessage="Rule"
            />
          </TableCell>
          {isUserAuthorisedForSettingsEdit ? (
            <TableCell>
              <div style={{ textAlign: "right" }}>
                <FormattedMessage
                  id="settings.indirecthc.header.action"
                  defaultMessage="Action"
                />
              </div>
            </TableCell>
          ) : (
            ""
          )}
        </TableRow>
        {
          // parseProcessRules(indirectHCData.processRules).map(item => renderRow(item))
          Object.values(indirectHCData)
            .filter((rules) => rules[CYCLE] === cycle)
            .map((rulesByCycleLevel) =>
              parseProcessRules(rulesByCycleLevel[PROCESS_RULES]).map((item) =>
                renderRow(item),
              ),
            )
        }
      </Table>
    </div>
  );
};

const getProcessListForSelect = (
  existingProcessList,
  includeProcessCode = "",
) => {
  const defaultProcessList = Object.keys(indirectHCProcessMap).map(
    (process) => indirectHCProcessMap[process],
  );
  const filteredDefaultProcessList = defaultProcessList.filter(
    (obj) => !associateOnlyProcesses.includes(obj.processName),
  );
  let processList = filteredDefaultProcessList.filter(
    (process) =>
      !existingProcessList.some(
        (existingProcess) => existingProcess[PROCESS] === process[PROCESS],
      ),
  );
  if (includeProcessCode) {
    if (!processList.some((item) => item[PROCESS] === includeProcessCode)) {
      processList.push(indirectHCProcessMap[includeProcessCode]);
    }
  }
  return processList;
};

const parseProcessRules = (processRules = []) => {
  return Object.keys(processRules).map((key) => {
    return {
      ...processRules[key],
      process: key,
    };
  });
};

const DeleteRuleModal = (props) => {
  const { viewModel, dispatch } = useContext(SettingsContext);
  const { openDeleteIndirectHCRuleModal, indirectHCRuleToDelete } =
    viewModel.settingsData;
  const onClose = useCallback(
    () => dispatch({ type: "CLOSE_DELETE_INDIRECT_HC_RULE_MODAL" }),
    [],
  );
  const onConfirm = useCallback(() => {
    indirectHCRuleToDelete && props.onConfirm(indirectHCRuleToDelete);
  }, [indirectHCRuleToDelete]);
  return (
    <React.Fragment>
      <Modal
        title="Delete Rule"
        open={openDeleteIndirectHCRuleModal}
        onClose={onClose}
        scrollContainer="viewport"
        closeLabel="Close"
        describedById="modal-description"
      >
        {!!indirectHCRuleToDelete && (
          <Text id="modal-description">
            <FormattedMessage
              id="settings.indirecthc.modal.deleteRuleWarning"
              defaultMessage="Are you sure you want to delete the rule for "
            />
            {
              indirectHCProcessMap[indirectHCRuleToDelete["process"]][
                "processName"
              ]
            }
            ?
          </Text>
        )}
        <ModalFooter>
          <Row alignmentHorizontal="right" widths="fit">
            <Button type="secondary" size="small" onClick={onClose}>
              <FormattedMessage
                id="settings.indirecthc.modal.cancel"
                defaultMessage="Cancel"
              />
            </Button>
            <Button type="primary" size="small" onClick={onConfirm}>
              <FormattedMessage
                id="settings.indirecthc.modal.confirm"
                defaultMessage="Confirm"
              />
            </Button>
          </Row>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

const inputWrapperStyle = {
  width: "14em",
};

const formWrapperStyle = {
  minHeight: "18em",
  boxSizing: "border-box",
  paddingTop: "3.2em",
};

const DEFAULT_FORM = {
  isUpdate: false,
  ruleType: INDIRECT_HC_RULE_TYPE_FIXED_HC,
  process: "",
  minAssociates: "",
  ratioToAssociatedProcess: "",
  associatedProcess: "",
  volume: "",
  rate: "",
  timeIntervalsWithMinAssociates: {},
  cycleName: DEFAULT_CYCLE,
};

const modalFooter = {
  paddingTop: "15px",
};

const ERROR_MSG_500 = "Something is wrong...";

const DEFAULT_FHCTIWMA = {
  minAssociates: 0,
  timeInterval: {
    localStartTime: "",
    localEndTime: "",
  },
};

export default injectIntl(IndirectHCView);



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/IndirectHC.js